import { instantBaseApi } from "../instantApi";
import { themePageQuery, themesQuery, themePageMutation, themePageCount, themePageUpdate, themePageDelete, themePagesGlobal, themePageDuplicate } from "./gpl";

export const pageApi = {
  getThemePageApi: async ({ after, before, first, last, orderBy, where, themeID, themePageMetasWhere, themePageMetasFirst }) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageQuery,
        variables: { after, before, first, last, orderBy, where, themeID, themePageMetasWhere, themePageMetasFirst }
      })
    );
  },

  getThemeApi: async () => {
    return await instantBaseApi(
      JSON.stringify({
        query: themesQuery,
        variables: {
          first: 1,
          where: {
            isPublished: true
          }
        }
      })
    );
  },

  unpublishPagesApi: async ({ themeId, ids }) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageMutation,
        variables: {
          themeId,
          ids
        }
      })
    );
  },

  getThemePageCountApi: async appType => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageCount,
        variables: {
          appType
        }
      })
    );
  },
  
  getThemePagesGlobal: async ({ after, before, first, last, orderBy, where, themeID }) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePagesGlobal,
        variables: { after, before, first, last, orderBy, where, themeID }
      })
    );
  },

  updateThemePageApi: async ({ pageId, input }) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageUpdate,
        variables: {
          id: pageId , 
          input: input,
        },
      })
    );
  }, 

  deleteThemePageApi: async (id) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageDelete,
        variables: { id },
      })
    );
  },

  duplicateThemePageApi: async (themePageDuplicateId, themeId) => {
    return await instantBaseApi(
      JSON.stringify({
        query: themePageDuplicate,
        variables: { themePageDuplicateId, themeId },
      })
    );
  }
};
